/**
 * BrandToolbar — Compact pill that groups the language selector + theme toggle
 * into a single bordered container in the top-right of the navbar. Gives the
 * navbar a finished, intentional look (vs floating loose elements).
 */
import LangToggle from "@/components/LangToggle";
import ThemeToggle from "@/components/ThemeToggle";

export default function BrandToolbar({ className = "" }) {
  return (
    <div
      className={`brand-toolbar inline-flex items-center gap-1 sm:gap-2 px-1.5 sm:px-2.5 py-1 sm:py-1.5 rounded-full ${className}`}
      data-testid="brand-toolbar"
    >
      <LangToggle />
      <span className="brand-toolbar-sep" aria-hidden="true" />
      <ThemeToggle />
    </div>
  );
}
